// src/services/linkPreviewService.js
//
// Verificação de links das notas. O navegador não consegue fazer isso: a política
// de mesma origem impede o front de ler a resposta de outro domínio (nem o status).
// O backend, que não tem origem a proteger, abre a conexão e devolve o veredito.
//
// CONTRATO ESPERADO DO BACKEND
//   POST /api/LinkPreview
//   body:     { "urls": ["https://…", "https://…"] }
//   resposta: { "items": [
//                 {
//                   "url":      "https://…",   // a mesma URL enviada
//                   "ok":       true,          // false → link quebrado
//                   "title":    "Título da página",   // opcional (OpenGraph/<title>)
//                   "imageUrl": "https://…/og-image.jpg" // opcional (og:image)
//                 }
//              ] }
//
// Sugestão de implementação: HEAD com timeout curto (≈3s), seguindo redirects;
// se o HEAD não for aceito, GET parcial. Cachear no servidor por algumas horas.
//
// Enquanto o endpoint não existir, este serviço devolve null e o front mantém o
// comportamento atual (previews sem selo de "quebrado", site com favicon).

import api from "@/services/api";

export async function fetchLinkPreviews(urls) {
  if (!Array.isArray(urls) || urls.length === 0) return null;

  try {
    const response = await api.post("/LinkPreview", { urls });
    const items = response?.data?.items;
    return Array.isArray(items) ? items : null;
  } catch (error) {
    // 404 (endpoint ainda não existe), rede fora, timeout: degrada em silêncio.
    console.warn(
      "⚠️ Verificação de links indisponível:",
      error?.response?.status ?? error?.message
    );
    return null;
  }
}
